import * as BABYLON from 'babylonjs'
export var Pantalla = function (obj, rutaVideo, radioRep, girarpX, girarpZ, dobleC) {
  var x = obj.position.x
  var z = obj.position.z
  var objeto = obj
  var video = rutaVideo
  var iniciado = false
  var girarX = girarpX
  var girarZ = girarpZ
  var dobleCara = dobleC
  var radio = radioRep

  var objetos = []
  var videoTexture

  var usarPadre = function () {
    x = obj.parent.position.x
    z = obj.parent.position.z
  }

  // Getters and setters
  var getIniciado = function () {
    return iniciado
  }

  var getRadio = function () {
    return radio
  }

  var getX = function () {
    return x
  }

  var getZ = function () {
    return z
  }

  var setIniciado = function (valor) {
    iniciado = valor
  }

  var setX = function (newX) {
    x = newX
  }

  var setZ = function (newZ) {
    z = newZ
  }

  var addPantalla = function (newObject) {
    objetos[objetos.length] = newObject
    // alert(objetos.length);
  }

  var cargarVideo = function () {
    // alert('cargando '+video)
    var matVideo = new BABYLON.StandardMaterial('matVideo', window.scene)
    videoTexture = new BABYLON.VideoTexture('video', [video], window.scene, true, true)
    matVideo.emissiveTexture = videoTexture
    objeto.material = matVideo

    if (girarX) {
      objeto.rotation.x = Math.PI * 180 / 180
    }
    if (girarZ) {
      objeto.rotation.z = Math.PI * 180 / 180
    }
    if (dobleCara) {
      objeto.material.backFaceCulling = false
    }

    for (var i = 0; i < objetos.length; i++) {
      // alert('addPantalla '+i)
      objetos[i].material = matVideo

      if (girarX) {
        objetos[i].rotation.x = Math.PI * 180 / 180
      }
      if (girarZ) {
        objetos[i].rotation.z = Math.PI * 180 / 180
      }
      if (dobleCara) {
        objetos[i].material.backFaceCulling = false
      }
    }
  }

  var pausarVideo = function () {
    videoTexture.video.pause()
  }

  var reproducirVideo = function () {
    videoTexture.video.play()
  }

  // Define which variables and methods can be accessed
  return {
    usarPadre: usarPadre,
    getIniciado: getIniciado,
    getRadio: getRadio,
    getX: getX,
    getZ: getZ,
    setX: setX,
    setZ: setZ,
    setIniciado: setIniciado,
    cargarVideo: cargarVideo,
    pausarVideo: pausarVideo,
    reproducirVideo: reproducirVideo,
    addPantalla: addPantalla
  }
}



// WEBPACK FOOTER //
// ./src/core/Pantalla.js